<template>
  <div class="container">
    <transition name="modal fade">
      <div class="modal-mask modal-backdrop dropdown_modal">
        <div class="modal-wrapper">
          <div class="modal-dialogs" role="document">
            <div class="modal-content modal-xs bg-transparent">
              <div class="modal-body mdScroll px-5 craft-weapon_list linear-gradient-color mb-3">
                <div class=" linear-gradient-color inner_content">
                <h1 class="tm5 modal-title d-inline-block">Withdraw Amount</h1>
                <a
                  href="JavaScript:void(0)"
                  class="btn-cross float-right close-modal"
                  @click="hideModal($event)"
                  >X</a
                >
                <p v-if="error">{{ error }}</p>
                <div class="text-center"></div>
                <div class="withdraw_inner">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Please enter withdraw amount, e.g 1"
                    v-model="amount"
                  />
                  <div class="form-group mt-4">
                    <select
                      id="my-select"
                      class="form-control"
                      name="type"
                      v-model="symbol"
                      @change="symbolChanged($event)"
                    >
                      <option value="MCC" selected>MCC</option>
                      <option value="WSW">WSW</option>
                      <option value="WSL">WSL</option>
                      <option value="WSM">WSM</option>
                    </select>
                  </div>
                  <div class="modal-body__btn-container mt-3">
                    <div class="d-flex buttons_group justify-content-between">
                      <button
                        class="btn active"
                        @click="addToCart(4)"
                        :class="
                          selectedQty == 4 ? 'btn-selected' : 'btn-dark'
                        "
                      >
                        25%
                      </button>
                      <button
                        class="btn not_active middle_btn"
                        @click="addToCart(2)"
                        :class="
                          selectedQty == 2 ? 'btn-selected' : 'btn-dark'
                        "
                      >
                        50%
                      </button>
                      <button
                        class="btn not_active"
                        @click="addToCart(1)"
                        :class="
                          selectedQty == 1 ? 'btn-selected' : 'btn-dark'
                        "
                      >
                        100%
                      </button>
                    </div>
                  </div>
                  <div class="help-block text-danger theme_font my-2">
                    <template v-if="!loading && balance.length>0">
                      <span class="help-block" v-if="mcc[0]">Total Coins: {{mcc[0].value/10000}} MCC</span>
                      <span class="help-block" v-if="wsw[0]">Total Woods: {{wsw[0].value/10000}} WSW</span>
                      <span class="help-block" v-if="wsl[0]">Total Leathers: {{wsl[0].value/10000}} WSL</span>
                      <span class="help-block" v-if="wsm[0]">Total Metals: {{wsm[0].value/10000}} WSM</span>
                   </template>
                  </div>
                  <button class="btn btn-dark theme_btn" @click="transfer()">
                    Withdraw
                  </button>
                </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
// import ApiService from "../services";
import ApiService from "../services";
// import VueLoadImage from "vue-load-image";
import "vue-loading-overlay/dist/vue-loading.css";
import { mapGetters } from "vuex";
import { useToast } from "vue-toastification";
const toast = useToast();
export default {
  name: "WithdrawModal",
  // components: {
  //   Loading,
  // },
  computed: {
    ...mapGetters(["balance", "mcc", "wsw", "wsl","wsm"]),
  },

  props: ["error", "withdrawModal"],
  
  data() {
    return {
      amount: null,
      token: false,
      symbol: "MCC",
      type: null,
      selectedQty: 4,
      // withdrawModal: true,
    };
  },

  methods: {
    hideModal(e) {
      this.$emit("w-modal-hide-click", e);
    },
    symbolChanged() {
      if (this.amount) {
        let total = 0;
        if (this.symbol == "MCC") {
          total = this.mcc[0].value / 10000;
        } else if (this.symbol == "WSL") {
          total = this.wsl[0].value / 10000;
        } else if (this.symbol == "WSM") {
          total = this.wsm[0].value / 10000;
        } else if (this.symbol == "WSW") {
          total = this.wsw[0].value / 10000;
        }
        const requiredAmount = total / this.selectedQty;
        this.amount = requiredAmount;
      }
    },
    addToCart(val) {
      this.selectedQty = val;
      this.symbolChanged();
    },
    async transfer() {
      if (!this.symbol || !this.amount) {
        toast.error("Please select amount and token type.");
        return;
      }
      const data = {
        contract: process.env.VUE_APP_CONTRACT,
        action: "withdraw",
        data: {
          account: localStorage.getItem("wax_user"),
          token: Number(this.amount).toFixed(4) + " " + this.symbol,
        },
      };
      await ApiService.transaction(
        data,
        (res) => {
          if (res.processed) {
            toast.success("Transaction successfull");
            ApiService.getBalance((res) =>
              this.$store.commit("addBalance", res.rows[0])
            );
          }
        },
        (error) => {
          toast.error(ApiService.errorFormat(error));
        }
      );
    },
  },
};
</script>

<style scoped>
.progress-cont .progress__bar {
  height: 9px !important;
}
.dropdown_modal .craft-weapon_list{
  width: 35vw;
  height: auto;
}
.inner_content{
  display: inline-block;
  width: 100%;
  padding: 20px;
  text-align: center;
}
.buttons_group .active{
  background-color: #273c75 !important;
  /*color: #000000;*/
}
.buttons_group .not_active{
  background-color: #537a8e;
}
.dropdown_modal .close-modal{
  font-family: JockeyOne !important;
  background: #e84218;
  padding: 5px 13px;
  border-radius: 5px;
  color: #fff;
  text-decoration: none;
  font-weight: bold;
  position: absolute;
  right: 8px;
  top: 20px;
}
.modal-dialogs{
  height: 100vh !important;
  display: flex;
}
.modal-content{
  margin: auto !important;
  height: fit-content !important;
  border: none;
}
.dropdown_modal{
  background-color: rgba(0,0,0,0.4);
}
.middle_btn{
  margin: 0 10px;
}
</style>
